import styled from "styled-components";

export const CruzamentoHeaderTexts = styled.div`
  position: relative;

  & > div > div {
    display: none !important;
  }

  .subtitle {
    color: #667085;
    margin-top: 4px;
    font-size: 16px;
    line-height: 24px;
  }

  span {
    font-size: 12px;
    font-family: "Poppins";
    font-weight: lighter;
    color: #515151;
    position: absolute;
    top: 4px;
    right: 0;
  }

  @media (max-width: 768px) {
    span {
      position: relative;
      top: -22px;
    }
  }
`;

export const CompareDataContainer = styled.div`
  min-width: 78vw;
  margin-top: -24px;
  /* background-color: #FCFCFC; */
`;

export const SelectContainer = styled.div`
  width: 100%;
  .MuiOutlinedInput-root {
    width: 100%;
  }

  .MuiInputBase-input {
    padding: 9px !important;
  }

  .MuiSvgIcon-root {
    margin-top: -3px;
  }

  label {
    margin-bottom: 13px;
  }
  legend {
    display: none;
  }
`;

export const TextFieldCityContainer = styled.div`
  width: 100%;
  .MuiFormLabel-root {
    margin-bottom: 3px;
  }
  .MuiFormControl-root {
    margin-top: 3px;
  }
`;

export const DateCalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* place-content: center; */
  .MuiFormLabel-root {
    margin-bottom: 3px;
  }

  .MuiInputBase-root {
    width: 255px;
  }

  .MuiFormControl-root {
    margin-top: 3px;
  }
  .MuiDateRangeCalendar-root {
    border-radius: 17.961px;
    /* width: 100%; */
    max-width: min-content;
    border: 1.048px solid #d8dadf;
    font-family: Inter;
    & > div:first-child {
      display: none;
    }

    & > div:nth-child(2) {
      width: 100%;
    }
  }
  .MuiPickersCalendarHeader-root {
    /* padding: 0 3rem 0 4rem; */
    margin-bottom: 24px;
    @media (max-width: 768px) {
      padding: inherit;
      padding-left: 1.5rem;
    }
  }

  .MuiButtonBase-root.Mui-selected[aria-selected="true"] {
    background: #efad1b;
    color: #344054;
  }

  .MuiButtonBase-root {
    color: #344054;
  }

  .MuiPickersCalendarHeader-root,
  .MuiPickersFadeTransitionGroup-root,
  .MuiButtonBase-root svg {
    color: #1259a5;
    font-family: Inter !important;
  }

  .MuiPickersCalendarHeader-label {
    text-transform: capitalize;
    font-weight: 600;
    font-size: 21px;
  }
  .MuiPickersSlideTransition-root {
    /* min-height: 220px; */
  }

  .MuiDayCalendar-header,
  .MuiDayCalendar-weekContainer {
    width: 100%;
    /* place-content: space-evenly; */
  }
`;

export const AllDataWrapper = styled.div`
  border-radius: 8px;
  /* padding: 12px; */
  padding-top: 0px;
  max-width: 1360px;
  margin: auto;
  /* margin-bottom: 64px; */
  .firstRow {
    margin-top: 18px;
    max-width: 932px;
    margin-bottom: 32px;
    & .MuiFormControl-root .MuiInputBase-root {
      width: 100%;
    }

    .MuiInputBase-root {
      height: 45px;
    }
  }

  .MuiCircularProgress-root {
    display: flex;
    place-self: center;
  }

  @media (max-width: 768px) {
    padding: 48px 32px;
    .firstRow,
    .flex-column-mobile {
      flex-direction: column;
    }
  }

  label {
    text-transform: uppercase;
    font-weight: bold;
    color: #383838;
    font-size: 18px;
    line-height: 24px;
  }

  fieldset {
    border-color: #4bbfef;
    border-radius: 8px;
  }

  .MuiChip-root {
    background: transparent;
    border: 1px solid #c8b4ff;
  }
`;

export const FirstCardsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 42px;

  .card {
    background-color: #fff;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 14px;
    padding: 16px;
    /* width: 262px; */
    width: 100%;
    height: 130px;
    box-shadow: 6px 6px 54px rgba(0, 0, 0, 0.05);

    .title {
      font-weight: 500;
      color: #666666;
      font-size: 16px;
      /* font-family: "Inter, Helvetica, Arial, sans-serif"; */
    }

    .value {
      font-weight: 600;
      color: #202224;
      font-size: 28px;
      letter-spacing: 1px;
      margin-top: 9px;
    }

    .percentContainer {
      display: flex;
      .percentUp {
        color: #00b69b;
      }
      .text {
        color: #858585;
        font-weight: 500;
        color: #202224;
        font-size: 14px;
      }
    }
  }

  .card:nth-of-type(2) {
    background-color: #ecfdf3;
  }

  .card:nth-of-type(5) {
    background-color: #fef3f2;
  }
`;

export const SystemUsageContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  padding: 24px 16px;
  width: 100%;
  box-shadow: 6px 6px 54px rgba(0, 0, 0, 0.05);
  gap: 32px;
  margin-bottom: 24px;

  .title {
    font-family: "Poppins";
    font-weight: 400;
    font-size: 24px;
    line-height: 20px;
    color: #202224;
  }

  .cardsContainer {
    width: 100%;
    height: 116px;
    display: flex;
    gap: 12px;

    .card {
      width: 100%;
      display: flex;
      justify-content: space-between;
      color: #202224;
      padding: 16px;
      border-radius: 14px;
      background-color: #ffffff;
      box-shadow: 6px 6px 54px rgba(0, 0, 0, 0.05);
      .text {
        opacity: 0.7;
        font-size: 16px;
      }

      .value {
        font-weight: 600;
        color: #202224;
        font-size: 28px;
        letter-spacing: 1px;
        margin-top: 9px;
      }

      .icon {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(249, 146, 42, 0.21);
        border-radius: 23px;
        align-self: center;

        svg {
          font-size: 32px;
          color: rgba(249, 146, 42);
        }
      }
    }
    .card:nth-of-type(2) {
      .icon {
        background-color: rgb(130, 128, 255, 0.21);
        svg {
          color: rgba(130, 128, 255);
        }
      }
    }
    .card:nth-of-type(3) {
      .icon {
        background-color: rgba(136, 197, 75, 0.21);
        svg {
          color: rgba(136, 197, 75, 1);
        }
      }
    }
    .card:nth-of-type(4) {
      .icon {
        background-color: rgba(255, 105, 180, 0.21);
        svg {
          color: rgba(255, 105, 180, 1);
        }
      }
    }
  }

  .tableContainer {
    .MuiPaper-root {
      border-radius: 14px;
      border: 0.3px solid rgba(224, 224, 224, 1);
      box-shadow: none;
    }
    thead th {
      font-weight: 600;
      color: #202224;
      font-size: 16px;
      height: 49px;
      padding-block: 0;
    }
    tbody tr {
      height: 58px;
    }

    .tableContainerLoading {
      min-height: 200px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
  }
`;

export const CustomChartContainer = styled.div`
  border-radius: 18px;
  background: #fff;
  box-shadow: 6px 6px 54px rgba(0, 0, 0, 0.05);
  padding: 20px 8px;
  max-width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CustomChartHeader = styled.div`
  display: flex;
  padding-left: 8px;
  align-items: center;
  gap: 4.67px;
  min-height: 42px;
`;

export const CustomChartTitle = styled.div`
  color: #202224;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  flex: 1 0 0;
`;
